import {
    IntlProvider,
    load,
    LocalizationProvider,
    loadMessages,
  } from "@progress/kendo-react-intl";
  
  import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
  import currencyData from "cldr-core/supplemental/currencyData.json";
  import weekData from "cldr-core/supplemental/weekData.json";
  
  import numbers from "cldr-numbers-full/main/he/numbers.json";
  import currencies from "cldr-numbers-full/main/he/currencies.json";

  import caGregorian from "cldr-dates-full/main/he/ca-gregorian.json";
  import dateFields from "cldr-dates-full/main/he/dateFields.json";
  import timeZoneNames from "cldr-dates-full/main/he/timeZoneNames.json";
  
  import heMessages from "./he.json";
  loadMessages(heMessages, "he");
  
  load(
    likelySubtags,
    currencyData,
    weekData,
    numbers,
    currencies,
    caGregorian,
    dateFields,
    timeZoneNames
  );
  
  export const Localization = (props) => {
    const { children } = props;
  
    return (
      <LocalizationProvider language="he">
        <IntlProvider locale="he-il">{children}</IntlProvider>
      </LocalizationProvider>
    );
  };
  